import styled from "styled-components";

export const CustomerActFRegisItemStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_3};
  padding: 16px 4px;
  .cus_info_block {
    margin-bottom: 27px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 6px;
    .mbr_name {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .btn_view_detail {
      border-radius: 20px;
      padding: 6px 30px;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      cursor: pointer;
    }
  }

  .mbr_status_info_row {
    margin-bottom: 22px;
    display: flex;
    justify-content: space-between;
    column-gap: 10px;
    &.mb_0 {
      margin-bottom: 0px;
    }
    .mrt_col {
      flex: 1;
      &.mw_half {
        max-width: 50%;
      }
      .cert_generate {
        text-align: center;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
      .mbr_status {
        border-radius: 50px;
        padding: 7px 6px;
        width: 100%;
        background: ${({ theme, statusBg }) =>
          statusBg ? statusBg : theme.COLORS.GREEN_2};
        text-align: center;
        color: ${({ theme, statusTxtBg }) =>
          statusTxtBg ? statusTxtBg : theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        cursor: pointer;
      }
      a {
        text-decoration: none;
      }
      .si_item {
        border-radius: 20px;
        padding: 6px 6px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 4px;
        background: ${({ theme }) => theme.COLORS.GREEN_2};
        text-align: center;
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        cursor: pointer;
        text-decoration: none;
        &.bg_gold {
          background: ${({ theme }) => theme.COLORS.GOLD_1};
        }
        &.bg_yellow {
          background: ${({ theme }) => theme.COLORS.YELLOW_1};
        }
        &.bg_blue {
          background: ${({ theme }) => theme.COLORS.BLUE_1};
        }
        &.bg_orange {
          background: ${({ theme }) => theme.COLORS.ORANGE_1};
        }
        &.bg_purple {
          border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_11};
          background: ${({ theme }) => theme.COLORS.WHITE_1};
          cursor: pointer;
          color: ${({ theme }) => theme.COLORS.PURPLE_11};
          &.fade {
            opacity: 0.6;
          }
        }
      }
    }
    .status_title {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.COLORS.GRAY_9};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }

  .mark_block {
    margin-top: 8px;
    .mark_label {
      color: ${({ theme }) => theme.COLORS.RED_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
  }

  .theme_standard {
  }
`;
